import produce from 'immer';
import { ISnackbarState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import { SnackbarAction } from '../actions/snackbarActions';

export const initialSnackbarState: ISnackbarState = {
  byId: {},
  ids: []
};

export default function snackbarReducer(
  state: ISnackbarState = initialSnackbarState,
  action: SnackbarAction
) {
  return produce(state, draft => {
    switch (action.type) {
      case actionTypes.SHOW_SNACKBAR:
        const id = Date.now();
        draft.byId[id] = {
          id,
          ...action.payload
        };
        draft.ids.push(id);
        break;

      case actionTypes.HIDE_SNACKBAR:
        draft.ids.splice(draft.ids.indexOf(action.payload.id), 1);
        delete draft.byId[action.payload.id];
        break;
    }
  });
}
